/**
 * Browser storage, restricted to an allow-list of PII-free keys.
 * Never store names, Emirates IDs, phone numbers, amounts or form values here.
 */
const KEYS = {
  sidebarCollapsed: 'dd.sidebarCollapsed',
  density: 'dd.density',
  recentRecords: 'dd.recentRecords', // [{ kind, id }] only, no labels
  locale: 'dealdesk.locale', // UI language code only, e.g. "ar"
  mockScenario: 'dd.mock.scenario',
  mockSession: 'dd.mock.session', // opaque mock session token (dev only)
} as const;

export type StorageKey = keyof typeof KEYS;

function store(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readStorage<T>(key: StorageKey, fallback: T): T {
  try {
    const raw = store()?.getItem(KEYS[key]);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeStorage(key: StorageKey, value: unknown): void {
  try {
    store()?.setItem(KEYS[key], JSON.stringify(value));
  } catch {
    /* storage unavailable (private mode); the app works without it */
  }
}

export function removeStorage(key: StorageKey): void {
  try {
    store()?.removeItem(KEYS[key]);
  } catch {
    /* ignore */
  }
}
